<template>
	<div></div>
</template>

<script>
const AMap = window.AMap;
export default {
	name: 'AMap',
	props: {
		mapDatas: {
			type: Object,
			require: true
		}
	},
	data() {
		return {
			map: '',
			marker: ''
		};
	},
	mounted() {
		// 初始化地图页面
		this.initMap();
	},
	beforeDestroy() {
		// 销毁地图
		this.map.destroy();
	},
	methods: {
		// 初始化地图页面
		initMap() {
			// 添加maker
			console.log('111111', this.mapDatas.dataList[0]);
			let lnglats = this.mapDatas.dataList[0]; //地图题
			// 地图初始化应该在地图容器div已经添加到DOM树之后
			this.map = new AMap.Map('mapContainer-' + this.mapDatas.id, {
				resizeEnable: true,
				center: [lnglats[1][0], lnglats[0][0]],
				zoom: 9
			});
			for (var j = 0; j < lnglats[0].length; j++) {
				var towarr = [];
				if (lnglats[1][j] != '') {
					towarr.push(parseFloat(lnglats[1][j]));
				}
				if (lnglats[0][j] != '') {
					towarr.push(parseFloat(lnglats[0][j]));
				}
				// TODO: 后端返回的数据经纬度相反，此处需要注意处理
				this.setMaker(towarr, lnglats[1][j] + ':' + lnglats[0][j], j);
			}
		},
		// 添加maker
		setMaker(laninfo, title, index) {
			var marker = new AMap.Marker({
				position: laninfo,
				title: title
			});
			// 设置标记点内容 1 2 3 ...
			marker.setLabel({
				offset: new AMap.Pixel(20, 20), //设置文本标注偏移量
				content: `<div class='info'>${index + 1}</div>`, //设置文本标注内容
				direction: 'right' //设置文本标注方位
			});
			this.map.add(marker);
			// 添加解析地理位置插件
			this.map.plugin('AMap.Geocoder', () => {
				// 异步加载插件
				this.geocoder = new AMap.Geocoder({
					city: this.defaultCity // 默认：“全国”
				});
			});
		}
	}
};
</script>

<style lang="scss">
.amap-marker-label {
	border: none;
	border-radius: 50%;
	background-color: transparent;
	width: 18px;
	height: 18px;
	padding: 0px;
	text-align: center;
	line-height: 18px;
	top: 0px !important;
	left: 0px !important;
}
.info {
	position: relative;
	// top: 0;
	// right: 0;
	min-width: 0;
	color: #fff;
}
</style>
